import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import { register } from "../actions/userActions";
import { useLocation, useNavigate } from "react-router-dom";

const RegisterScreen = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [confirmPassMessage, setConfirmPassMessage] = useState(null);

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const userRegister = useSelector((state) => state.userRegister);
  const { loading, error, userRegisterInfo } = userRegister;

  const redirect = location.search ? location.search.split("=")[1] : "/login";

  useEffect(() => {
    if (userRegisterInfo) {
      setConfirmPassMessage(
        "Te enviamos un correo de confirmación. Revisa tu bandeja de entrada o correo no deseado para activar tu cuenta."
      );
    }
  }, [navigate, userRegisterInfo, redirect]);

  const submitHandler = (e) => {
    e.preventDefault();
    setMessage(null);
    if (password !== confirmPassword) {
      setMessage("Las contraseñas no coinciden");
    } else if (!acceptedTerms) {
      setMessage(
        "Debes aceptar los Términos y Condiciones y el Aviso de Privacidad para continuar."
      );
    } else {
      dispatch(register(name, email, password, acceptedTerms));
    }
  };

  return (
    <div className="hadacy-auth">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');

        /* ─── HADACY · auth screens (login / register / forgot password) ───
           Single visual system shared across all three screens. Centered
           card with a serif heading + gold hairline, soft cream inputs,
           pill CTA, secondary-action footer link. The same .hadacy-auth
           namespace is redeclared in each screen so they all flip in
           sync via dark-mode.css. */
        .hadacy-auth {
          --cream: #f5f0e8;
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --muted: #7a6e62;
          --card-bg: #faf7f2;
          --recess: #efe7d8;
          --danger: #b04a3c;
          font-family: "Jost", sans-serif;
          max-width: 480px;
          margin: 2.5rem auto;
          padding: 0 1rem;
        }
        .hadacy-auth__card {
          background: var(--card-bg);
          border: 1px solid rgba(184, 147, 58, 0.18);
          border-radius: 16px;
          padding: 2.4rem 2.2rem;
          box-shadow: 0 14px 40px rgba(26, 20, 16, 0.06);
        }
        @media (max-width: 480px) {
          .hadacy-auth__card { padding: 1.8rem 1.4rem; }
        }
        .hadacy-auth__brand {
          text-align: center;
          font-size: 0.66rem;
          letter-spacing: 0.42em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.6rem;
        }
        .hadacy-auth__heading {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          letter-spacing: 0.02em;
          color: var(--dark);
          font-size: 2.1rem;
          line-height: 1.15;
          text-align: center;
          margin: 0 0 0.4rem 0;
        }
        .hadacy-auth__heading::after {
          content: "";
          display: block;
          width: 36px; height: 1px;
          background: var(--gold);
          margin: 0.7rem auto 0;
        }
        .hadacy-auth__lede {
          text-align: center;
          font-size: 0.88rem;
          color: var(--muted);
          margin: 0 0 1.6rem 0;
          line-height: 1.55;
        }

        .hadacy-auth__group { margin-bottom: 0.95rem; }
        .hadacy-auth__label {
          display: block;
          font-size: 0.62rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
          font-weight: 400;
          margin-bottom: 0.35rem;
        }
        .hadacy-auth__input {
          width: 100%;
          background: #fff;
          border: 1px solid rgba(184, 147, 58, 0.22);
          border-radius: 10px;
          padding: 0.7rem 0.95rem;
          font-family: "Jost", sans-serif;
          font-size: 0.95rem;
          color: var(--dark);
          box-shadow: none;
          transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
        }
        .hadacy-auth__input:focus {
          outline: none;
          border-color: var(--gold);
          background: #fff;
          box-shadow: 0 0 0 3px rgba(184, 147, 58, 0.14);
        }
        .hadacy-auth__input::placeholder {
          color: var(--muted);
          font-style: italic;
          opacity: 0.85;
        }

        .hadacy-auth__password { position: relative; }
        .hadacy-auth__password .hadacy-auth__input { padding-right: 2.6rem; }
        .hadacy-auth__eye {
          position: absolute;
          top: 50%; right: 0.75rem;
          transform: translateY(-50%);
          background: transparent;
          border: 0;
          color: var(--muted);
          font-size: 0.95rem;
          cursor: pointer;
          padding: 0.3rem;
          border-radius: 999px;
          transition: color .2s ease, background .2s ease;
        }
        .hadacy-auth__eye:hover {
          color: var(--gold);
          background: rgba(184, 147, 58, 0.08);
        }

        .hadacy-auth__cta {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.55rem;
          width: 100%;
          padding: 0.9rem 1.5rem;
          margin-top: 0.6rem;
          border-radius: 999px;
          background: var(--dark);
          border: 1px solid var(--dark);
          color: var(--gold-light);
          font-family: "Jost", sans-serif;
          font-size: 0.72rem;
          letter-spacing: 0.24em;
          text-transform: uppercase;
          cursor: pointer;
          transition: background .2s ease, color .2s ease, border-color .2s ease, transform .2s ease;
        }
        .hadacy-auth__cta:hover:not(:disabled),
        .hadacy-auth__cta:focus:not(:disabled) {
          background: var(--gold);
          border-color: var(--gold);
          color: var(--dark);
        }
        .hadacy-auth__cta:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .hadacy-auth__terms {
          display: flex;
          align-items: flex-start;
          gap: 0.6rem;
          margin: 0.4rem 0 0.2rem;
          font-size: 0.82rem;
          line-height: 1.5;
          color: var(--muted);
          cursor: pointer;
        }
        .hadacy-auth__checkbox {
          margin-top: 0.2rem;
          width: 1rem;
          height: 1rem;
          accent-color: var(--gold);
          flex: 0 0 auto;
          cursor: pointer;
        }
        .hadacy-auth__terms a {
          color: var(--gold);
          font-weight: 500;
          text-decoration: none;
        }
        .hadacy-auth__terms a:hover { color: var(--dark); text-decoration: underline; }

        .hadacy-auth__footer {
          text-align: center;
          font-size: 0.85rem;
          color: var(--muted);
          margin-top: 1.4rem;
          letter-spacing: 0.01em;
        }
        .hadacy-auth__footer + .hadacy-auth__footer { margin-top: 0.4rem; }
        .hadacy-auth__footer a {
          color: var(--gold);
          font-weight: 500;
          text-decoration: none;
          letter-spacing: 0.02em;
        }
        .hadacy-auth__footer a:hover { color: var(--dark); text-decoration: underline; }

        .hadacy-auth__banner {
          padding: 0.65rem 0.85rem;
          border-radius: 10px;
          margin-bottom: 1rem;
          font-size: 0.85rem;
          line-height: 1.45;
          border: 1px solid;
          display: flex;
          align-items: flex-start;
          gap: 0.55rem;
        }
        .hadacy-auth__banner i { margin-top: 2px; }
        .hadacy-auth__banner--danger {
          background: rgba(176, 74, 60, 0.08);
          border-color: rgba(176, 74, 60, 0.32);
          color: var(--danger);
        }
        .hadacy-auth__banner--info {
          background: rgba(184, 147, 58, 0.10);
          border-color: rgba(184, 147, 58, 0.32);
          color: var(--gold);
        }
      `}</style>

      <div className="hadacy-auth__card">
        <div className="hadacy-auth__brand">HADACY</div>
        <h1 className="hadacy-auth__heading">Crear cuenta</h1>
        <p className="hadacy-auth__lede">
          Únete para descubrir nuestra colección de cosméticos y perfumes.
        </p>

        {confirmPassMessage && (
          <div className="hadacy-auth__banner hadacy-auth__banner--info">
            <i className="fas fa-envelope"></i>
            <span>{confirmPassMessage}</span>
          </div>
        )}
        {message && (
          <div className="hadacy-auth__banner hadacy-auth__banner--danger">
            <i className="fas fa-exclamation-circle"></i>
            <span>{message}</span>
          </div>
        )}
        {error && (
          <div className="hadacy-auth__banner hadacy-auth__banner--danger">
            <i className="fas fa-exclamation-circle"></i>
            <span>{error}</span>
          </div>
        )}
        {loading && <Loader />}

        <form onSubmit={submitHandler} noValidate>
          <div className="hadacy-auth__group">
            <label htmlFor="name" className="hadacy-auth__label">
              Nombre
            </label>
            <input
              id="name"
              type="text"
              className="hadacy-auth__input"
              placeholder="Tu nombre completo"
              value={name}
              autoComplete="name"
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="hadacy-auth__group">
            <label htmlFor="email" className="hadacy-auth__label">
              Correo electrónico
            </label>
            <input
              id="email"
              type="email"
              className="hadacy-auth__input"
              placeholder="tu@correo.com"
              value={email}
              autoComplete="email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="hadacy-auth__group">
            <label htmlFor="password" className="hadacy-auth__label">
              Contraseña
            </label>
            <div className="hadacy-auth__password">
              <input
                id="password"
                type={passwordVisible ? "text" : "password"}
                className="hadacy-auth__input"
                placeholder="Crea una contraseña segura"
                value={password}
                autoComplete="new-password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="hadacy-auth__eye"
                onClick={() => setPasswordVisible((v) => !v)}
                aria-label={
                  passwordVisible ? "Ocultar contraseña" : "Mostrar contraseña"
                }
              >
                <i
                  className={
                    passwordVisible ? "fas fa-eye-slash" : "fas fa-eye"
                  }
                ></i>
              </button>
            </div>
          </div>

          <div className="hadacy-auth__group">
            <label htmlFor="confirmPassword" className="hadacy-auth__label">
              Confirmar contraseña
            </label>
            <div className="hadacy-auth__password">
              <input
                id="confirmPassword"
                type={confirmVisible ? "text" : "password"}
                className="hadacy-auth__input"
                placeholder="Repite tu contraseña"
                value={confirmPassword}
                autoComplete="new-password"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                className="hadacy-auth__eye"
                onClick={() => setConfirmVisible((v) => !v)}
                aria-label={
                  confirmVisible ? "Ocultar contraseña" : "Mostrar contraseña"
                }
              >
                <i
                  className={
                    confirmVisible ? "fas fa-eye-slash" : "fas fa-eye"
                  }
                ></i>
              </button>
            </div>
          </div>

          <label className="hadacy-auth__terms">
            <input
              type="checkbox"
              className="hadacy-auth__checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <span>
              He leído y acepto los{" "}
              <Link to="/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">
                Términos y Condiciones
              </Link>{" "}
              y el{" "}
              <Link to="/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">
                Aviso de Privacidad
              </Link>
              .
            </span>
          </label>

          <button
            type="submit"
            className="hadacy-auth__cta"
            disabled={loading || !acceptedTerms}
          >
            Registrarse <i className="fas fa-arrow-right"></i>
          </button>
        </form>

        <p className="hadacy-auth__footer">
          ¿Ya tienes una cuenta?{" "}
          <Link to={redirect ? `/login?redirect=${redirect}` : "/login"}>
            Iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterScreen;
